import http from '~/common/http'
export default {
    // 成交订单分析统计
    getList(params) {
        return http.get('/api/knowledge-base/index', {
            params: params
        });
    },
    create(data) {
        return http.post("/api/knowledge-base/create", data);
    },

    update(data) {
        return http.put("/api/knowledge-base/update", data);
    },

    delete(id) {
        return http.delete("/api/knowledge-base/delete", {
            params: {
                id: id
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/KnowledgeBase.js